<template>
  <div class="container-fluid">
    <div class="mb-3">
      <div class="h3 font-weight-bold my-0">
        Create New Exam
      </div>
      <div class="text-muted my-0">
        <span class="text-primary">Home</span> / Exam / New
      </div>
    </div>
    <div class="card p-4">
      <div>
        <!-- Exam Details -->
        <div class="h5">Exam Details:</div>
        <b-form-group label="Exam Title" label-for="exam-title">
          <b-form-input
            id="exam-title"
            v-model="exam.title"
            placeholder="Enter exam title"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Description" label-for="exam-description">
          <b-form-textarea
            id="exam-description"
            v-model="exam.description"
            placeholder="Enter exam description"
            rows="3"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group label="Duration (in minutes)" label-for="exam-duration">
          <b-form-input
            id="exam-duration"
            v-model="exam.duration"
            type="number"
            placeholder="Enter exam duration"
            required
          ></b-form-input>
        </b-form-group>

        <!-- Questions -->
        <h5 v-if="exam.questions.length" class="mt-4">Questions:</h5>
        <div
          v-for="(question, index) in exam.questions"
          :key="index"
          class="mb-4"
        >
          <QuestionForm
            :question="question"
            :questionTypes="questionTypes"
            @remove="removeQuestion(index)"
          />
        </div>

        <b-button variant="primary" class="" @click="addQuestion">
          Add Question
        </b-button>

        <!-- Submit -->
        <b-button variant="success" class="ml-1" @click="submitExam">
          Save Exam
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionForm from "./components/QuestionForm.vue";

export default {
  components: { QuestionForm },
  data() {
    return {
      exam: {
        title: "",
        description: "",
        duration: "",
        questions: [],
      },
      questionTypes: [
        { value: "multiple-choice", text: "Multiple Choice" },
        { value: "identification", text: "Identification" },
        { value: "essay", text: "Essay" },
      ],
    };
  },
  methods: {
    addQuestion() {
      this.exam.questions.push({
        text: "",
        question_type: "multiple-choice",
        points: 1,
        options: [],
        answer: "",
      });
    },
    removeQuestion(index) {
      this.exam.questions.splice(index, 1);
    },
    submitExam() {
      // Prepare a plain object by removing Vue's reactivity
      const plainExam = JSON.parse(JSON.stringify(this.exam));

      // Dispatch Vuex action with the plain object
      this.$store
        .dispatch("exam/create", { ...plainExam })
        .then((res) => {
          console.log("createexam", res);
          this.$router.push({ name: "Exam", query: { created: "true" } });
          this.showToast("Exam created successfully!", "success");
        })
        .catch((err) => {
          console.error("Error creating exam:", err);
        });
    },
    showToast(message, variant = "info") {
      this.$bvToast.toast(message, {
        title: "Notification",
        variant,
        autoHideDelay: 5000,
        solid: true,
      });
    },
  },
};
</script>
